import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const DrugSchema = z.object({
  drugId: z.string(),
  brandName: z.string(),
  genericName: z.string().nullable(),
  manufacturer: z.string().nullable(),
  description: z.string().nullable(),
  dosageForm: z.string().nullable(),
  strength: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Drug = z.infer<typeof DrugSchema>;

export const DrugsSchema = z.array(DrugSchema);

export type Drugs = z.infer<typeof DrugsSchema>;

export const DrugsQuerySchema = createOffsetPaginationRequestQuerySchema(
  z.enum([
    'brandName',
    'genericName',
    'manufacturer',
    'createdAt',
    'updatedAt',
  ]),
).merge(
  z.object({
    drugIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    brandNameLike: z.string().optional(),
    genericNameLike: z.string().optional(),
    manufacturerLike: z.string().optional(),
    dosageForms: commaDelimitedList(z.string().array()).optional(),
  }),
);

export type DrugsQuery = z.infer<typeof DrugsQuerySchema>;

export const CreateDrugSchema = DrugSchema.pick({
  brandName: true,
  genericName: true,
  manufacturer: true,
  description: true,
  dosageForm: true,
  strength: true,
});

export type CreateDrug = z.infer<typeof CreateDrugSchema>;
